import { render } from "./CodeRegiFormUnit.vue?vue&type=template&id=db9063c4"
import script from "./CodeRegiFormUnit.vue?vue&type=script&lang=js"
export * from "./CodeRegiFormUnit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__